export enum NumberOfParticipantsDropdownDataHooks {
  DROPDOWN = 'number-of-participants-dropdown',
}
